import { render, staticRenderFns } from "./Users-Single.vue?vue&type=template&id=2919f253&"
import script from "./Users-Single.vue?vue&type=script&lang=js&"
export * from "./Users-Single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports